import {
  getSession as requestGetSession,
  logIn as requestLogIn,
  logOut as requestLogOut,
  updateUser as requestUpdateUser,
  resetPassword as requestPasswordReset
} from "@utils/aegean_api_handler";

export const GET_SESSION_REQUEST = "GET_SESSION_REQUEST";
export const GET_SESSION_SUCCESS = "GET_SESSION_SUCCESS";
export const GET_SESSION_ERROR = "GET_SESSION_ERROR";
export const UPDATE_USER_REQUEST = "UPDATE_USER_REQUEST";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const UPDATE_USER_ERROR = "UPDATE_USER_ERROR";
export const RESET_PASSWORD_REQUEST = "RESET_PASSWORD_REQUEST";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
export const LOGIN_REQUEST = "LOGIN_REQUEST";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_ERROR = "LOGIN_ERROR";
export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_ERROR = "LOGOUT_ERROR";

export const fetchSession = () => (dispatch, getState) => {
  const store = getState();

  if (store.session.isFetching || store.session.data) {
    // Request for (somewhat) static data - no need for multiple requests
    return Promise.resolve();
  }

  dispatch({ type: GET_SESSION_REQUEST });

  return requestGetSession()
    .then(({ organization, user }) => {
      dispatch({
        type: GET_SESSION_SUCCESS,
        organization,
        user
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_SESSION_ERROR,
        error
      });
    });
};

export const updateUser = (user_id, user) => (dispatch) => {
  dispatch({ type: UPDATE_USER_REQUEST });

  return requestUpdateUser(user_id, user)
    .then(({ response: { user } }) => {
      dispatch({
        type: UPDATE_USER_SUCCESS,
        user
      });
    })
    .catch((error) => {
      dispatch({
        type: UPDATE_USER_ERROR,
        error
      });
    });
};

export const resetPassword = (data, captchaResponse) => async (dispatch) => {
  dispatch({ type: RESET_PASSWORD_REQUEST });

  try {
    const { organization, user } = await requestPasswordReset(data, captchaResponse);
    dispatch({
      type: RESET_PASSWORD_SUCCESS,
      organization,
      user
    });
  } catch (error) {
    dispatch({
      type: RESET_PASSWORD_ERROR,
      error
    });
    throw error;
  }
};

export const logIn = (data, captchaResponse) => async (dispatch, getState) => {
  const store = getState();

  if (store.session.isFetching || store.session.data) {
    // Request for (somewhat) static data - no need for multiple requests
    return Promise.resolve();
  }

  dispatch({ type: LOGIN_REQUEST });

  try {
    const { organization, user } = await requestLogIn(data, captchaResponse);
    dispatch({
      type: LOGIN_SUCCESS,
      organization,
      user
    });
  } catch (error) {
    dispatch({
      type: LOGIN_ERROR,
      error
    });
    throw error;
  }
};

export const logOut = () => (dispatch, getState) => {
  const store = getState();

  if (store.session.isFetching) {
    // Request for (somewhat) static data - no need for multiple requests
    return Promise.resolve();
  }

  dispatch({ type: LOGOUT_REQUEST });
  return requestLogOut()
    .then((response) => {
      if (response && response.skip_dispatch_logout_success) {
        // pass
      } else {
        dispatch({
          type: LOGOUT_SUCCESS
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: LOGOUT_ERROR,
        error
      });
    });
};
